<template>
  <div>
    <v-btn :id="elementId" :aria-label="elementId" :outline="selectedCount === 0" color="primary" @click="showModal">
      <span :class="{'primary-text': selectedCount !== 0, 'dark-adjustment': $vuetify.dark && selectedCount === 0}">{{buttonText}}</span>
    </v-btn>

    <v-dialog v-model="modal" :max-width="modalWidth">
      <v-card>
        <v-container>
          <h2 class="text-xs-center">{{buttonTitle}}</h2>
          <v-layout v-if="!courseHierarchySelected" row justify-start>
            <v-icon class="mr-1">mdi-blank</v-icon>
            <v-text-field class="mr-4 pt-1" clearable append-icon="search" v-model="searchText" :placeholder="$t('admin.alerts.list_search_placeholder')"></v-text-field>
          </v-layout>
          <v-layout v-else row justify-start>
            <v-icon class="mr-1">mdi-blank</v-icon>
            <v-text-field class="mr-4 pt-1" clearable append-icon="search" v-model="searchHierarchy" v-on:keyup="searchTreeHierarchy" :placeholder="$t('admin.alerts.list_search_placeholder')"></v-text-field>
          </v-layout>
          <div v-if="modal">
            <div v-if="courseHierarchySelected" class="pl-3 pt-3">
              <tree-node :tree="tree" v-bind="{openNode, tickNode}"></tree-node>
            </div>
            <div v-else class="filter-list-rows">
              <transition-group name="filter-list">
                <div v-for="(row, key) in filteredRows" :key="source.key(row)" :class="tableRowClass">
                  <filter-list-row :row="source.mapRow(row)" :idSet="idSet" :row-key="key" @selected="selected"></filter-list-row>
                </div>
              </transition-group>
            </div>
          </div>
        </v-container>

        <v-card-actions>
          <v-layout row justify-center class="pt-1 pb-1">
            <div v-if="courseHierarchySelected">
              <v-btn @click="clearHierarchy" :disabled="disableHierarchyClearButton">{{$t('student.filters.clear')}}</v-btn>
            </div>
            <div v-else>
              <v-btn @click="clear" :disabled="selectedCount === 0">{{$t('student.filters.clear')}}</v-btn>
            </div>
              <v-btn @click="closeModal" color="primary">{{$t('student.filters.okay')}}</v-btn>
          </v-layout>
        </v-card-actions>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import FilterListRow from '../../filter/FilterListRow'
  import Helpers from '../../../mixins/Helpers'
  import { mapState, mapMutations, mapActions } from 'vuex'
  import TreeNode from '../../tree/TreeNode'
  import {SET_CLASS_HIERARCHY_OPEN, SET_CLASS_HIERARCHY_TICK, SET_ALERT_COURSES, SET_CLASS_HIERARCHY_SELECTIONS, SET_ALERT_LIST_FILTER_ARRAY} from '../../../store/mutation-types'
  import {SAVE_ADMIN_ALERT_HIERARCHY, EDIT_ALERT_DETAILS, GET_SEARCH_HIERARCHY_RESULTS} from '../../../store/action-types'

  export default {
    name: 'filter-list',
    mixins: [Helpers],
    data () {
      return {
        modal: false,
        searchText: '',
        searchHierarchy: '',
        courseHierarchySelected: false,
        courseIdentifier: [],
        disableHierarchyClearButton: true
      }
    },
    methods: {
      getCourseIdentifiers () {
        if (this.alert.courseIds !== undefined) {
          this.alert.courseIds.forEach(courseId => {
            const courseVal = this.courseList.find(course => course.id === courseId)
            this.courseIdentifier.push(courseVal.courseIdentifier)
          })
          return (this.courseIdentifier)
        } else {
          return []
        }
      },
      openNode (id, expanded) {
        this.openTreeNode({id, expanded})
      },
      tickNode (id, ticked) {
        this.tickTreeNode({id, ticked})
        let courses = this.getHierarchyClassIds()
        this.saveCourseIds(courses)
        courses.length === 0 ? this.disableHierarchyClearButton = true : this.disableHierarchyClearButton = false
        this.$store.dispatch(EDIT_ALERT_DETAILS, {alertId: this.alert.id, alert: this.$store.state.admin.newSingleAlert})
        this.setCourseFilterDetails({filterName: courses, filterType: this.filterType})
      },
      showModal () {
        if (this.filterName === 'courseIds') {
          this.courseHierarchySelected = true
          this.courseIdentifier = []
          if (this.tree !== null) {
            if (this.getCourseIdentifiers() !== []) {
              this.disableHierarchyClearButton = false
              this.setHierarchySelection(this.getCourseIdentifiers())
            }
          }
        }
        this.modal = true
      },
      closeModal () {
        this.searchHierarchy = ''
        this.courseIdentifier = []
        this.courseHierarchySelected = false
        this.modal = false
        if (this.filterName === 'courseIds') {
          this.searchTreeHierarchy()
        }
      },
      clear () {
        this.$emit('filter:list-change', {filterName: [], filterType: this.filterType})
      },
      clearHierarchy () {
        this.tickNode(this.parentId, false)
      },
      searchTreeHierarchy: function () {
        this.$store.dispatch(GET_SEARCH_HIERARCHY_RESULTS, {searchText: this.searchHierarchy})
        if (this.alert.courseIds !== undefined) {
          this.setHierarchySelection(this.getCourseIdentifiers())
        }
      },
      ...mapMutations({
        openTreeNode: SET_CLASS_HIERARCHY_OPEN,
        tickTreeNode: SET_CLASS_HIERARCHY_TICK,
        saveCourseIds: SET_ALERT_COURSES,
        setHierarchySelection: SET_CLASS_HIERARCHY_SELECTIONS,
        setCourseFilterDetails: SET_ALERT_LIST_FILTER_ARRAY
      }),
      ...mapActions({
        saveAdminHierarchy: SAVE_ADMIN_ALERT_HIERARCHY
      }),
      selected (selection) {
        let ids = new Set(this.idSet)
        if (selection.selected) {
          ids.add(selection.id)
        } else {
          ids.delete(selection.id)
        }
        this.$emit('filter:list-change', {filterName: Array.from(ids.keys()), filterType: this.filterType})
      },
      getHierarchyClassIds () {
        return Array.from(this.mapping.values()).filter(node => node.ticked && node.isCourse).map(node => node.databaseId)
      }
    },
    props: {
      source: {
        type: Object,
        required: true
      },
      filterType: {
        type: String,
        required: true
      },
      elementId: {
        type: String
      },
      filterName: {
        type: String
      }
    },
    computed: {
      ...mapState({
        tree: state => state.hierarchy.tree,
        mapping: state => state.hierarchy.mapping,
        parentId: state => state.hierarchy.parentId,
        alert: state => state.admin.newSingleAlert,
        courseList: state => state.admin.alertFilterFields.courseIds.courses
      }),
      idSet () {
        let ids = new Set()
        Object.keys(this.source.idValues).forEach(id => {
          if (this.source.identifier === 'course' || this.source.identifier === 'courseYears') {
            ids.add(parseInt(id))
          } else {
            ids.add(id)
          }
        })
        return ids
      },
      selectedCount () {
        return Object.keys(this.source.idValues).length
      },
      buttonTitle () {
        return this.$t(this.source.title_i18n) + ' Selection'
      },
      buttonText () {
        if (this.selectedCount === 0) {
          return 'All ' + this.$t(this.source.button_unselected_i18n)
        } else {
          // original
          let x = this.$t(this.source.button_i18n, {count: this.selectedCount}, this.selectedCount)
          // remove count to look up in translations
          let y = this.$t(x.substring(x.indexOf(this.selectedCount) + this.selectedCount.toString().length + 1, x.length))
          // re-apply count to translated text
          return this.selectedCount + ' ' + y
        }
      },
      filteredRows () {
        let text = (this.searchText === null) ? '' : this.searchText
        return this.source.items.filter(item => this.source.containsText(item, text))
      },
      modalWidth () {
        return this.filterName === 'courseIds' ? 550 : 350
      }
    },
    components: {
      FilterListRow,
      TreeNode
    }
  }
</script>

<style scoped>
  .filter-list-rows {
    overflow: auto;
    height: 55vh;
    max-height: calc(100vh - 340px);
    -webkit-overflow-scrolling: touch;
  }

  .dark-adjustment {
    color: white;
  }

  .progress-wheel {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/alert/AlertFilterList.vue